// extracted by mini-css-extract-plugin
module.exports = {"activeContainer":"BadgeList_activeContainer__2b9uV","inactiveContainer":"BadgeList_inactiveContainer__ucopl","spin":"BadgeList_spin__26prQ"};